var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapitulatifMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "42px",
    viewBox: "0 0 82 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 82
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.289473684 0 21.7105263 0 21.7105263 13.3913043 0.289473684 13.3913043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accueil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QUESTION2",
    transform: "translate(-148.000000, -608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(189.000000, 629.000000) rotate(-270.000000) translate(-189.000000, -629.000000) translate(168.000000, 588.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5,-1.8189894e-12 L42.5,-1.8189894e-12 C65.1436747,-1.82314898e-12 83.5,18.3563253 83.5,41 L83.5,41 C83.5,63.6436747 65.1436747,82 42.5,82 L41.5,82 C18.8563253,82 0.5,63.6436747 0.5,41 L0.5,41 C0.5,18.3563253 18.8563253,-1.81482983e-12 41.5,-1.8189894e-12 Z",
    id: "Rectangle-3-Copy-3",
    fill: "#DEE2E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(22.500000, 41.000000) rotate(-90.000000) translate(-22.500000, -41.000000) translate(11.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.500000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9594233,0 C15.9252718,0.043911733 15.892247,0.0889323481 15.8571802,0.132104826 C14.5709735,1.71484928 12.8460087,2.58650457 11,2.58650457 C9.15392085,2.58650457 7.42895611,1.71484928 6.14274938,0.132104826 C6.10768254,0.0889323481 6.07472816,0.043911733 6.0405063,0 C2.6562039,1.62347739 0.289473684,5.21499881 0.289473684,9.35889139 L0.289473684,12.0287839 C0.289473684,12.7812713 0.870541126,13.3913043 1.58729894,13.3913043 L20.4126306,13.3913043 C21.1294589,13.3913043 21.7105263,12.7812713 21.7105263,12.0287839 L21.7105263,9.35889139 C21.7105263,5.21499881 19.3437257,1.62347739 15.9594233,0",
    id: "Fill-1",
    fill: "#01205C",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5806106,12.1299486 C16.7607651,10.8516491 17.5,9.02688337 17.5,7 C17.5,3.13404627 14.813674,0 11.5000372,0 C8.18625151,0 5.5,3.13404627 5.5,7 C5.5,9.02688337 6.23923485,10.8516491 7.4193149,12.1299486 C8.49007726,13.2898089 9.9236433,14 11.5000372,14 C13.0763567,14 14.5099227,13.2898089 15.5806106,12.1299486 Z",
    id: "Fill-4",
    fill: "#01205C"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapitulatifMobile);
export default __webpack_public_path__ + "static/media/recapitulatif-mobile.f4bb4010eeff1b9e8b9e09b7cf9a84df.svg";
export { ForwardRef as ReactComponent };